import React from 'react';

import { type IntlShape } from 'react-intl-next';

import { DefaultExtensionProvider } from '@atlaskit/editor-common/extensions';
import { token } from '@atlaskit/tokens';
import {
	type CustomSitesExtensionProviderProps,
	type ExtensionMode,
	getExtensionManifest,
	KNOWLEDGE_CARDS_EXTENSION_TYPE,
} from '@atlassian/company-hub-common';

import { KNOWLEDGE_CARDS_EXTENSION_KEY } from '../../constants';
import type { KnowledgeCardsParameters as KnowledgeCardsParametersType } from '../../types';

import { i18n } from './messages';

// ADD knowledge cards extension with loadable

export const knowledgeCardsParameters = (intl: IntlShape) => ({
	extensionTitle: intl.formatMessage(i18n.title),
});

export type knowledgeCardsExtensionProviderWrapperProps = {
	contentId: string;
	mode: ExtensionMode;
};

export const knowledgeCardsExtensionProvider = async ({
	contentId,
}: knowledgeCardsExtensionProviderWrapperProps) => {
	return async ({
		editorActions,
		openConfigPanel,
		setUpsellModalSource,
		intl,
	}: CustomSitesExtensionProviderProps) => {
		const title = intl.formatMessage(i18n.title);
		const description = intl.formatMessage(i18n.description);
		const type = KNOWLEDGE_CARDS_EXTENSION_TYPE;
		const render = async () => {
			return () => (
				<div data-testid="knowledge-cards-extension"> Knowledge Cards! contentId: {contentId} </div>
			);
		};
		const icons = {
			// ADD correct icon. this is a placeholder for now
			// eslint-disable-next-line import/dynamic-import-chunkname
			'48': () =>
				import(
					/* webpackChunkName: "@atlaskit-internal_atlaskit-icon-core-premium" */ '@atlaskit/icon/core/premium'
				).then(({ default: PremiumIcon }) => () => (
					<PremiumIcon color={token('color.icon.subtle')} label="" spacing="spacious" />
				)),
		};

		const parameters = knowledgeCardsParameters(intl);

		const update = async () => {
			const selectedNode = editorActions?.getSelectedNode()?.toJSON();
			const selectedLocalId = selectedNode?.attrs?.localId;

			if (!!selectedLocalId && openConfigPanel) {
				openConfigPanel(selectedLocalId);
			}
		};

		return new DefaultExtensionProvider([
			getExtensionManifest<KnowledgeCardsParametersType>({
				key: KNOWLEDGE_CARDS_EXTENSION_KEY,
				icons,
				parameters,
				render,
				update,
				title,
				type,
				description,
				setUpsellModalSource,
				source: 'knowledgeCardsInsert',
			}),
		]);
	};
};
